import View from './view';
export const IconLinkLogin = View;
